/** The key that opens, focuses and closes Edge AI. One home: show it from here. */
export const AI_CHAT_KEYS = ['mod', 'k']

/**
 * Mod+K: Cmd on Apple keyboards, Ctrl elsewhere. Ctrl+K on a Mac deletes to
 * line end in text fields, so Apple matches Cmd only.
 */
export function isAiChatShortcut(e: KeyboardEvent, apple: boolean): boolean {
  if (e.repeat || e.isComposing || e.altKey || e.shiftKey) return false
  if (apple ? !e.metaKey || e.ctrlKey : !e.ctrlKey || e.metaKey) return false
  const key = e.key.toLowerCase()
  // Latin layouts follow the typed letter (Dvorak); others fall back to the physical key.
  return /^[a-z]$/.test(key) ? key === 'k' : e.code === 'KeyK'
}

/** True for dialogs portaled outside the app root (modals, popovers), except the chat itself. */
export function isBlockedTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element) || target.closest('[data-companion-surface]')) return false
  const dialog = target.closest('[role="dialog"], [role="alertdialog"]')
  return dialog !== null && !document.getElementById('root')?.contains(dialog)
}

export type ChatShortcutAction = 'open' | 'focus' | 'close'

export function nextChatAction(s: { open: boolean; focusInChat: boolean }): ChatShortcutAction {
  if (!s.open) return 'open'
  return s.focusInChat ? 'close' : 'focus'
}
